module.exports = __webpack_public_path__ + "static/media/farmacia-guadalajara.ec5c1356.svg";